import React from 'react';
import { string, bool, func } from 'prop-types';

/**
 * ProfileNav.
 * @returns {React.component} The profile navigation to render.
 */
const ProfileNav = (props) => {
  const { activeView } = props;
  return (
    <nav className="profile-nav">
      <button
        className={`profile-nav__button ${(activeView === 'activity') ? 'profile-nav__button--active' : ''}`}
        onClick={props.updateActiveView} 
        name="activity">
        Activity
      </button>
      {props.actingUserCanEdit &&
        <button 
          className={`profile-nav__button ${(activeView === 'settings') ? 'profile-nav__button--active' : ''}`} 
          onClick={props.updateActiveView} 
          name="settings">
          Settings
        </button>
      }
    </nav>
  )
};

/**
 * Validation on passed-in props.
 * @type {Object}
 */
ProfileNav.propTypes = {
  activeView: string,
  updateActiveView: func,
  actingUserCanEdit: bool,
};

export default ProfileNav;



// WEBPACK FOOTER //
// ./src/components/ProfileNav/ProfileNav.js